import { Locale } from '@ps-smart-cp/ppfw-client';

const acquiredMergerNameConfig = {
  mergedAssets: new Map([
    [Locale.ja, '合併受入'],
    [Locale.en, 'Acquired by Merger'],
  ]),
  other: new Map([
    [Locale.ja, 'その他'],
    [Locale.en, 'other'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { acquiredMergerNameConfig };
